import { DownloadAllPopupAction, DownloadAllPopupActionKeys } from './actions';

export interface DownloadAllPopupState {
	closedByUser: boolean;
}

const initialState: DownloadAllPopupState = {
	closedByUser: false,
};

export function downloadAllPopup(state: DownloadAllPopupState = initialState, action: DownloadAllPopupAction): DownloadAllPopupState {
	switch (action.type) {
		case DownloadAllPopupActionKeys.CLOSE:
			return {
				...state,
				closedByUser: true,
			};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadAllPopup/reducer.ts